import { EdsData } from "@coworker/app/src/components/RoomSettings/types/article";
import { ItemStockStatus } from "@coworker/apprestructured/src/shared/components/item-cards/ItemStock/ItemStockStatus";
import { isFoodArticleHfb } from "@coworker/apprestructured/src/shared/helpers/item.helper";
import { ItemStockInfo } from "@coworker/apprestructured/src/shared/hooks/item/useItemStock";
import { MediaItemEds } from "../MediaItemEds/MediaItemEds";
import styles from "./ItemStockAndEds.module.css";

type ItemStockAndEdsProps = {
  stockInfo?: ItemStockInfo;
  edsData?: EdsData | null;
  hfb?: string;
};

export const ItemStockAndEds = ({
  stockInfo,
  edsData,
  hfb,
}: ItemStockAndEdsProps) => {
  return (
    <div className={styles["item-stock-eds-container"]}>
      <ItemStockStatus data={stockInfo} isFoodArticle={isFoodArticleHfb(hfb)} />
      {edsData && <MediaItemEds edsData={edsData} />}
    </div>
  );
};
